import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/Common";
import { quotaText } from "@/components/QuotaBanner";

const FINAL_FAIL = ["expired", "failed", "mismatch"];

export default function PaymentResult() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [st, setSt] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid || st?.credited || FINAL_FAIL.includes(st?.status) || tries >= 15) return;
    const t = setTimeout(() => {
      api.get(`/payments/status/${sid}`).then(({ data }) => setSt(data)).catch(() => setSt({ status: "notfound" })).finally(() => setTries((n) => n + 1));
    }, tries === 0 ? 0 : 2000);
    return () => clearTimeout(t);
  }, [sid, st, tries]);

  if (sid && !st) return <Loader text="Verifica del pagamento…" />;
  const ok = st?.credited;
  const failed = !sid || st?.status === "notfound" || FINAL_FAIL.includes(st?.status);
  const [Icon, title, text] = ok
    ? [CheckCircle2, "Pagamento confermato", `Abbiamo accreditato ${st.credits} analisi. ${quotaText(st.balance)}.`]
    : failed
      ? [XCircle, "Pagamento non completato", "Il pagamento non risulta completato: non è stata accreditata alcuna analisi."]
      : [Clock, "Pagamento in verifica", "Stiamo attendendo la conferma di Stripe. Le analisi verranno accreditate automaticamente appena il pagamento sarà confermato."];

  return (
    <div className="space-y-5 px-6 py-10" data-testid="payment-result-page">
      <Icon size={40} className={ok ? "text-[#059669]" : failed ? "text-[#B91C1C]" : "text-[#B39257]"} />
      <h1 className="font-serif text-3xl font-semibold text-[#0d2517]" data-testid="payment-result-title">{title}</h1>
      <p className="text-sm text-[#2D3A30]" data-testid="payment-result-text">{text}</p>
      {ok && <Link to="/analisi/nuova" className="btn-primary w-full" data-testid="payment-new-analysis">NUOVA ANALISI</Link>}
      {failed && <Link to="/acquista" className="btn-primary w-full" data-testid="payment-retry">TORNA AI PACCHETTI</Link>}
      <Link to="/profilo" className="btn-secondary w-full bg-white" data-testid="payment-go-profile">Vai al Profilo</Link>
    </div>
  );
}
